import React from "react";
import cx from "classnames";
import { FormikField } from "../Fields/Field";

/**
 * @param {object} props - The component props.
 * @param {boolean} props.isStandardDonationForm
 * @param {string} props.manualMatchingCompanyLabel
 * @param {string} props.manualMatchingAmountLabel
 * @returns {React.JSX.Element}
 */
const ManualEmployerMatchingFields = ({
    isStandardDonationForm,
    manualMatchingCompanyLabel,
    manualMatchingAmountLabel,
}) => (
    <>
        {/* Employer Field */}
        <div className="col col--12">
            <div className="grid">
                <div
                    className={cx(
                        "col col--12 -padding-left--15",
                        !isStandardDonationForm && "col--md-6",
                    )}
                >
                    <FormikField
                        id="Employer"
                        name="Employer"
                        label={manualMatchingCompanyLabel}
                        type="text"
                    />
                </div>
            </div>
        </div>
        {/* Amount Field */}
        <div className="col col--12 ">
            <div className="grid">
                <div
                    className={cx(
                        "col col--12 -padding-left--15",
                        !isStandardDonationForm && "col--md-6",
                    )}
                >
                    <FormikField
                        id="Matching-Gift-Amount"
                        name="Matching_Gift_Amount"
                        label={manualMatchingAmountLabel}
                        type="text"
                    />
                </div>
            </div>
        </div>
    </>
);

export default ManualEmployerMatchingFields;
